var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pleitos-detalhar',{attrs:{"dataServicos":_vm.obterDataServicos(),"rotaListagem":"Pleitos_Financeiro"}})
}
var staticRenderFns = []

export { render, staticRenderFns }